import { Button, Col, Form, Row } from 'react-bootstrap';

// The presentational contact form exactly as it shipped before the send logic
// was restored. It has no submit handler, so the browser performs its default
// form submission and the page reloads -- nothing is sent anywhere.
//
// This is the fallback/safe state. It has no dependencies beyond react-bootstrap
// and cannot throw, so it can never take the site down.
//
// See contactFormConfig.js for how to switch to ContactFormLive.
function ContactFormStatic() {
  return (
    <Form className="contact-form">
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="contactName">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" placeholder="Your name" />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="contactCompany">
            <Form.Label>Company</Form.Label>
            <Form.Control type="text" placeholder="Your company" />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="contactEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" placeholder="you@company.com" />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3" controlId="contactPhone">
            <Form.Label>Phone</Form.Label>
            <Form.Control type="tel" placeholder="Phone number" />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-3" controlId="contactInterest">
        <Form.Label>What are you interested in?</Form.Label>
        <Form.Select defaultValue="">
          <option value="" disabled>
            Select an option
          </option>
          <option>Safety &amp; inspection applications</option>
          <option>Systems integration</option>
          <option>Replacing spreadsheets</option>
          <option>Something else</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-4" controlId="contactMessage">
        <Form.Label>Message</Form.Label>
        <Form.Control as="textarea" rows={5} placeholder="How can we help?" />
      </Form.Group>
      <Button variant="" type="submit" className="btn-primary-ir">
        Send Message
      </Button>
    </Form>
  );
}

export default ContactFormStatic;
